import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=b957e6f4&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=js&"
export * from "./newsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=b957e6f4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./newsDetail.vue?vue&type=style&index=1&id=b957e6f4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b957e6f4",
  null
  
)

export default component.exports